import classNames from 'classnames';
import React, { useState } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import { FormFieldHeader } from '../FormFieldHeader';

interface PropTypes {
  type: string;
  registerReturn?: UseFormRegisterReturn;
  setValueOnChange?: (value: string) => void;
  error?: string;
  fieldName?: string;
  placeholder?: string;
  isRequired?: boolean;
  hideRequireIndicator?: boolean;
  classNames?: string;
  headerClassNames?: string;
  errorClassNames?: string;
  value?: string | number;
  disabled?: boolean;
  hideHeader?: boolean;
  maxLength?: number;
  minimumCharacters?: number;
  fontSize?: string;
  defaultValue?: string | number | readonly string[];
  showMaxLengthCounter?: boolean;
  showMaxLengthText?: boolean;
  invalidInput?: boolean;
  tooltipText?: string;
}

export function InputFormField(props: PropTypes) {
  const hideHeader = props.hideHeader ?? false;
  const [textCount, setTextCount] = useState(
    props.type == 'text' ? (props.value as string)?.length : null || 0,
  );

  return (
    <>
      {!hideHeader && (
        <FormFieldHeader
          fieldName={props.fieldName}
          isRequired={props.isRequired}
          hideRequireIndicator={props.hideRequireIndicator}
          classNames={props.headerClassNames}
          maximumCharacters={props.showMaxLengthText && props.maxLength}
          minimumCharacters={props.minimumCharacters}
          fontSize={props.fontSize}
          tooltipText={props.tooltipText}
        />
      )}
      <input
        className={classNames(
          'form-control',
          (props.invalidInput || props.error) && 'form-border-danger',
          props.classNames,
        )}
        defaultValue={props.defaultValue}
        maxLength={props.maxLength}
        type={props.type}
        placeholder={props.placeholder}
        {...props.registerReturn}
        onChange={(e) => {
          setTextCount(e.target.value.length);
          props.registerReturn?.onChange(e);
          props.setValueOnChange && props.setValueOnChange(e.target.value);
        }}
        disabled={props.disabled}
        value={props.value}
      />
      {(props.error || props.showMaxLengthCounter) && (
        <div className='d-flex justify-content-between mt-2'>
          <small
            className={classNames('text-danger-500', props.errorClassNames)}
          >
            {props.error || ''}
          </small>
          {props.showMaxLengthCounter && props.maxLength && (
            <small className='text-dark-200'>
              {textCount || 0}/{props.maxLength}
            </small>
          )}
        </div>
      )}
    </>
  );
}
